import { upperSnakeCaseToLowerCase } from './upperSnakeCaseToLowerCase';

export function getErrorText(parsedDetails) {
  const errorType = parsedDetails.errorType;
  if (errorType) {
    if (errorType === 'USER_ACTION') {
      return `User Action${
        parsedDetails.userAction
          ? ': ' + upperSnakeCaseToLowerCase(parsedDetails.userAction)
          : ''
      }`;
    }
    if (errorType === 'INVALID_TACTIC_UPDATE') {
      return `Invalid Tactic Update${
        parsedDetails.tacticName
          ? ': ' + upperSnakeCaseToLowerCase(parsedDetails.tacticName)
          : ''
      }`;
    }
    if (errorType === 'TACTIC_VALIDATION') {
      return `Tactic Validation${
        parsedDetails.tacticName
          ? ': ' + upperSnakeCaseToLowerCase(parsedDetails.tacticName)
          : ''
      }`;
    }
    return upperSnakeCaseToLowerCase(errorType);
  } else return '';
}
